import React from 'react';
import UserIcon from '@tradera/blueprint/theme/icons2/user-fill.svg?jsx';

type ProfileProps = {
    isLoggedIn: boolean;
    facebookId: string;
};

export const Profile = ({ isLoggedIn, facebookId }: ProfileProps) =>
    isLoggedIn && facebookId ? (
        <img
            alt="Profile"
            width="24"
            height="24"
            src={`https://graph.facebook.com/v3.2/${facebookId}/picture?type=square&height=48&width=48`}
            className="slim-header__profile-image"
        />
    ) : (
        <>
            <UserIcon
                className={`icon icon-md ${
                    isLoggedIn ? 'd-block' : 'd-block d-lg-none'
                }`}
            />
        </>
    );
